const MuiAccordion = ({ _palette }) => ({
  styleOverrides: {
    root: { boxShadow: 'none' },
  },
});

export default MuiAccordion;
